module.exports = __webpack_public_path__ + "media/images/places/black_remove-8b35ef6f8bf7599e0abfcc06acabaa7f.png";